import React from 'react'
import { Redirect } from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import ProjectForm from './ProjectForm'
import ProjectCard from './ProjectCard'

import Resource from '../../stores/resource'
const ProjectStore = Resource('projects')

class NewProject extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      project: this.props.attributes || {},
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null,
      redirectPush: true
    }
  }

  _save = attributes => {
    // Adjust attributes
    delete attributes.clientName
    delete attributes.agencyName
    delete attributes.agencyProducerName

    // Massage data
    attributes.producerId = attributes.userId // For now
    attributes.targetMargin = Number(attributes.targetMargin) / 100
    attributes.date = attributes.date || new Date()

    // Create!
    ProjectStore.create(attributes)
      .then(result => {
        const newProject = result.data.data
        const newProjectId = newProject.id
        this.setState(
          {
            saved: true,
            error: '',
            savedProject: newProject,
            snackbarMessage: `Project "${attributes.name}" created!`
          },
          () => {
            if (this.props.savedCallback) {
              this.props.savedCallback(this.state.savedProject)
            }
            setTimeout(
              () =>
                this.setState({
                  redirect: `/projects/${newProjectId}/edit`,
                  redirectPush: false
                }),
              500
            )
          }
        )
      })
      .catch(error => {
        this.setState({
          saved: false,
          error: errors.unpack(error)
        })
      })
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  _closeSuccessDialog = () =>
    this.setState({
      redirect: `/projects`,
      redirectPush: true
    })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    if (this.state.redirect)
      return (
        <Redirect push={this.state.redirectPush} to={this.state.redirect} />
      )

    const saved = this.state.saved

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog} />
    ]

    return (
      <section>
        <ProjectForm
          action="new"
          formTitle={this.props.formTitle}
          date={this.props.date}
          name={this.props.name}
          contacts={this.props.contacts}
          tags={this.props.tags}
          budget={this.props.budget}
          estimatedCost={this.props.estimatedCost}
          targetMargin={this.props.targetMargin}
          project={this.props.project}
          clientName={this.props.clientName}
          clientId={this.props.clientId}
          agencyName={this.props.agencyName}
          agencyId={this.props.agencyId}
          agencyProducerName={this.props.agencyProducerName}
          agencyProducerId={this.props.agencyProducerId}
          userId={this.props.userId}
          forceChanged={this.props.forceChanged}
          submitCallback={this._save}
          cancelCallback={this.props.cancelCallback}
        />

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create project"
        >
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved &&
          this.props.showSuccessDialog && (
            <Dialog
              actions={successDialogActions}
              modal={false}
              onRequestClose={this._closeSuccessDialog}
              open={Boolean(this.state.saved)}
              title="Project created"
            >
              <p>
                A new project has been created with the information below.<br />
                If you see any incorrect information, press the{' '}
                <strong>Edit</strong> button.
              </p>
              <ProjectCard
                project={this.state.savedProject}
                editCallback={() =>
                  this._redirectTo(
                    `/projects/${this.state.savedProject.id}/edit`
                  )
                }
              />
            </Dialog>
          )}
      </section>
    )
  }
}

export default NewProject



// WEBPACK FOOTER //
// ./src/components/Projects/NewProject.jsx